var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import get from 'lodash/get';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, Events, JourneysSelectors, TrackingActions, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject } from 'conversional-components';
import Fullscreen from '../components/Fullscreen';
import { CLOSED, OPEN } from './General.styles';
import { useListener } from '../utils/listener';
import { triggerSessionReplay } from '../utils/errorTracker';
/**
 * Entry View
 * Toggles view/hide of the entry point
 * Usually renders it in Fullscreen mode
 */
var Entry = function (_a) {
    var onApplyStyles = _a.onApplyStyles, root = _a.root, modalProps = _a.modalProps;
    //   utils.focusModal() => TODO: rewrite the function to trigger onc eon modal open to not scroll the background
    // TODO: Z-index management of active window!
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(false), animationCompleted = _c[0], setAnimationCompleted = _c[1];
    React.useEffect(function () {
        var isFirefoxBrowser = navigator.userAgent.includes('Firefox');
        if (!isFirefoxBrowser && !animationCompleted)
            return;
        var openStyles = get(root, 'Window.iframeStyles', OPEN);
        open ? sendToHost.iframeOnScreen() : sendToHost.iframeOffScreen();
        sendToHost.styleIframe(open ? __assign(__assign({}, openStyles), { zIndex: 2147483600 }) : CLOSED, true);
        open && onApplyStyles();
    }, [open, animationCompleted]);
    var onAnimationComplete = function () {
        setAnimationCompleted(true);
    };
    var onLogCta = function (_a) {
        var cta = _a.cta, label = _a.label;
        dispatch(CommonActions.logCta(cta, label));
    };
    var show = function () {
        trackEvent(Events.JOURNEY_ENTRY);
        dispatch(CommonActions.broadcastSharedStoreChange({
            journeyIsOpen: true,
        }));
        triggerSessionReplay(true);
        setOpen(true);
    };
    var hide = function () {
        trackEvent(Events.JOURNEY_ENTRY_HIDE);
        dispatch(CommonActions.broadcastSharedStoreChange({
            journeyIsOpen: false,
        }));
        triggerSessionReplay(false);
        setOpen(false);
    };
    var clear = function () {
        dispatch(CommonActions.clearState());
        show();
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_ENTRY, show);
    useListener(MESSAGETYPES.JOURNEY_CLOSE, hide);
    useListener(MESSAGETYPES.JOURNEY_RESULT_READY, hide);
    useListener(MESSAGETYPES.JOURNEY_RESTART, clear);
    useListener(MESSAGETYPES.JOURNEY_SET_CTA, onLogCta);
    if (!open) {
        return null;
    }
    return (_jsx(Fullscreen, { modalProps: modalProps, onClose: hide, onAnimationComplete: onAnimationComplete, children: _jsx(_Fragment, { children: createComponentsFromObject({ root: root }) }) }));
};
export default Entry;
